module.exports = __webpack_public_path__ + "static/img/cont35 (1).3de4ea8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont35 (1).jpg
// module id = SoA3
// module chunks = 0